import { MonetaryInputField, Text } from '@/components';
import { useLocaledAmount } from '@/providers';
import { formatValueByUnit } from '@/utils';
import { type FC, useCallback } from 'react';
import { type Path, useFormContext, useWatch } from 'react-hook-form';
import type { FundBusinessFormValues } from '../../../../_model/fund-business';
import { updateInvestmentBalance } from '../../../../_utils/form-control';

type Props = {
  name: Path<FundBusinessFormValues>;
  readOnly: boolean;
  minYear: number;
  yearIndex: number;
  rowIndex: number;
  isOthers?: boolean;
};

export const CalculateResultOrInput: FC<Props> = ({
  name,
  readOnly,
  minYear,
  yearIndex,
  rowIndex,
  isOthers,
}) => {
  const { unit } = useLocaledAmount();
  const {
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useFormContext<FundBusinessFormValues>();
  const watchValue = useWatch<FundBusinessFormValues>({ control, name });

  const setCalculateLoanBalance = useCallback(
    (inputValue: number | null) => {
      if (readOnly || isOthers) {
        return;
      }
      const performances = getValues('performances');
      updateInvestmentBalance({
        performances,
        inputValue,
        rowIndex,
        readOnly,
        yearIndex,
        minYear,
        setValue,
      });
    },
    [getValues, minYear, setValue, yearIndex, rowIndex, readOnly, isOthers],
  );

  return readOnly ? (
    <Text
      text={
        typeof watchValue === 'number'
          ? formatValueByUnit(Number(watchValue), {
              operation: 'round',
              unit,
              showUnitLabel: true,
            })
          : null
      }
    />
  ) : (
    <MonetaryInputField
      name={name}
      control={control}
      errors={errors}
      unit={unit}
      marginBottom={0}
      shouldCoexistOnChange
      onChange={setCalculateLoanBalance}
    />
  );
};
